var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconarrowright(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.7813 8.00047L5.48145 4.70062L6.42426 3.75781L10.6669 8.00047L6.42426 12.2431L5.48145 11.3003L8.7813 8.00047Z",
    fill: "#7D7E82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconarrowright);
export default __webpack_public_path__ + "static/media/icon.arrow.right.9f69cde43180db57f0cf1ad00e39c95c.svg";
export { ForwardRef as ReactComponent };